var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSellEur(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62.997,
    height: 42,
    viewBox: "0 0 62.997 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_1202",
    x: 15.409,
    y: 11.199,
    width: 85.638,
    height: 47.267,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3032",
    "data-name": "Path 3032",
    d: "M9.35,30.3a20,20,0,1,0,20-20,20,20,0,0,0-20,20",
    transform: "translate(-9.35 -10.305)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_sell-eur",
    transform: "translate(-15.302 -48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4492",
    "data-name": "Group 4492",
    transform: "translate(38.301 49.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "united-states",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M20,0A20,20,0,1,1,0,20,20,20,0,0,1,20,0Z",
    fill: "#f1f1f1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370",
    transform: "translate(0.691 4.359)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M244.87,194.447h20.921a20.073,20.073,0,0,0-.691-5.23H244.87Z",
    transform: "translate(-226.485 -178.791)",
    fill: "#d80000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    d: "M244.87,60.882h17.979a20.158,20.158,0,0,0-4.626-5.23H244.87Z",
    transform: "translate(-226.485 -55.652)",
    fill: "#d80000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    d: "M109.073,460.707a19.831,19.831,0,0,0,12.429-4.359H96.644A19.831,19.831,0,0,0,109.073,460.707Z",
    transform: "translate(-89.766 -425.068)",
    fill: "#d80000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M11.065,328.012H45.188a19.958,19.958,0,0,0,2.246-5.23H8.819A19.957,19.957,0,0,0,11.065,328.012Z",
    transform: "translate(-8.819 -301.931)",
    fill: "#d80000"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    d: "M9.287,3.131h1.827l-1.7,1.235.649,2-1.7-1.235-1.7,1.235.561-1.726A20.16,20.16,0,0,0,3.337,8.972h.585l-1.082.786q-.253.422-.485.857l.517,1.59-.964-.7q-.359.761-.656,1.556l.569,1.752h2.1l-1.7,1.235.649,2-1.7-1.235-1.018.74A20.243,20.243,0,0,0,0,20.05H20.05V0A19.955,19.955,0,0,0,9.287,3.131Zm.777,14.914-1.7-1.235-1.7,1.235.649-2-1.7-1.235h2.1l.649-2,.649,2h2.1l-1.7,1.235Zm-.649-7.838.649,2-1.7-1.235L6.665,12.2l.649-2-1.7-1.235h2.1l.649-2,.649,2h2.1Zm7.841,7.838-1.7-1.235-1.7,1.235.649-2-1.7-1.235h2.1l.649-2,.649,2h2.1l-1.7,1.235Zm-.649-7.838.649,2-1.7-1.235-1.7,1.235.649-2-1.7-1.235h2.1l.649-2,.649,2h2.1Zm0-5.841.649,2-1.7-1.235-1.7,1.235.649-2-1.7-1.235h2.1l.649-2,.649,2h2.1Z",
    fill: "#0052b4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4493",
    "data-name": "Group 4493",
    transform: "translate(16.302 49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_253",
    "data-name": "Ellipse 253",
    transform: "translate(-0.001)",
    fill: "#fff",
    stroke: "#2665a4",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4312",
    "data-name": "Group 4312",
    transform: "translate(0.001 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2035",
    "data-name": "Rectangle 2035",
    width: 47.605,
    height: 47.954,
    transform: "translate(-3.713 -4.092)",
    fill: "#00237c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3020",
    "data-name": "Path 3020",
    d: "M55.96,15.753l.614,1.887h1.984l-1.605,1.166.613,1.888L55.96,19.528l-1.606,1.167.613-1.888-1.606-1.166h1.985Z",
    transform: "translate(-35.884 -13.59)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3021",
    "data-name": "Path 3021",
    d: "M55.96,92.557l.614,1.888h1.984l-1.605,1.166.613,1.888L55.96,96.332,54.354,97.5l.613-1.888-1.606-1.166h1.985Z",
    transform: "translate(-35.884 -59.894)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3022",
    "data-name": "Path 3022",
    d: "M94.431,54.283l.613,1.887h1.985l-1.606,1.167.614,1.888-1.606-1.167-1.606,1.167.613-1.888L91.833,56.17h1.985Z",
    transform: "translate(-59.078 -36.819)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3023",
    "data-name": "Path 3023",
    d: "M17.558,54.154l.613,1.888h1.985L18.55,57.209l.613,1.888-1.606-1.167L15.952,59.1l.614-1.888L14.96,56.042h1.985Z",
    transform: "translate(-12.732 -36.741)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3024",
    "data-name": "Path 3024",
    d: "M22.678,34.7l.614,1.887h1.985L23.67,37.752l.614,1.888-1.606-1.167L21.072,39.64l.613-1.888L20.08,36.585h1.985Z",
    transform: "translate(-15.819 -25.011)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3025",
    "data-name": "Path 3025",
    d: "M36.375,20.617l.613,1.888h1.985l-1.606,1.166.613,1.888-1.606-1.167-1.606,1.167.614-1.888L33.776,22.5h1.985Z",
    transform: "translate(-24.076 -16.522)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3026",
    "data-name": "Path 3026",
    d: "M88.6,34.7l.614,1.887H91.2l-1.606,1.167.613,1.888L88.6,38.473,87,39.64l.613-1.888L86,36.585h1.985Z",
    transform: "translate(-55.563 -25.011)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3027",
    "data-name": "Path 3027",
    d: "M74.777,20.617,75.39,22.5h1.985l-1.606,1.166.613,1.888-1.606-1.167-1.606,1.167.614-1.888L72.178,22.5h1.985Z",
    transform: "translate(-47.228 -16.522)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3028",
    "data-name": "Path 3028",
    d: "M22.678,73.1l.614,1.888h1.985L23.67,76.154l.614,1.887-1.606-1.166-1.606,1.166.613-1.887L20.08,74.987h1.985Z",
    transform: "translate(-15.819 -48.163)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3029",
    "data-name": "Path 3029",
    d: "M36.375,86.8l.613,1.888h1.985l-1.606,1.167.613,1.887-1.606-1.167-1.606,1.167.614-1.887-1.606-1.167h1.985Z",
    transform: "translate(-24.076 -56.42)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3030",
    "data-name": "Path 3030",
    d: "M88.6,73.1l.614,1.888H91.2l-1.606,1.167.613,1.887L88.6,76.875,87,78.041l.613-1.887L86,74.987h1.985Z",
    transform: "translate(-55.563 -48.163)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3031",
    "data-name": "Path 3031",
    d: "M74.777,86.8l.613,1.888h1.985l-1.606,1.167.613,1.887-1.606-1.167-1.606,1.167.614-1.887-1.606-1.167h1.985Z",
    transform: "translate(-47.228 -56.42)",
    fill: "#fc0"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSellEur);
export default __webpack_public_path__ + "static/media/icon_sell_eur.cc101e4840fdbfa47ca15dfdd830b37e.svg";
export { ForwardRef as ReactComponent };